import { useState } from 'react';
import { faqs } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">FAQ</span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Everything you need to know about the Vigorbuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-2">{faq.question}</span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${openIndex === idx ? 'bg-primary-100 rotate-180' : 'bg-background-100'}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-500 mb-4">Still have questions about Vigorbuy Spreadsheet?</p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            Visit Main Platform
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}